var map = {
	"./activities@3x.png": 81825,
	"./calendar@3x.png": 53582,
	"./food@3x.png": 34412,
	"./list@3x.png": 26768,
	"./location@3x.png": 3515,
	"./message@3x.png": 10883,
	"./photos@3x.png": 13301,
	"./profile@3x.png": 27601,
	"./residence@3x.png": 54680,
	"./shopping@3x.png": 79872,
	"./survey@3x.png": 28854,
	"./websites@3x.png": 96334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81796;